import React from 'react';
import { ButtonText, ButtonIcon } from '../buttons';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

/**
 * PrimaryRaisedButton base component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const PrimaryFlatButton = ( {text, icon, handleClick, className, ...props} ) => {

    const StyledButton = styled(Button)`
  
        margin: ${(props) => props.theme.space[8]} 0;
 
        & {
          padding: 0.25em;
        }
    `;

    const Icon = icon ? <ButtonIcon icon={icon} iconColor="dark" {...props}/> : null;
    return (
        <StyledButton color="primary" onClick={handleClick} >
            {Icon}
            <ButtonText buttonText={text} />
        </StyledButton>
    );
};


export default PrimaryFlatButton;



// WEBPACK FOOTER //
// ./src/components/buttons/PrimaryFlatButton.js